<template>
  <v-dialog
    v-model="show"
    max-width="650"
    class="assign-new-user-membership-modal"
    scrollable
    persistent
  >
    <v-card>
      <v-card-title>
        <h4 class="mb-1">Add New User Membership</h4>
      </v-card-title>

      <v-divider class="mb-5" />

      <v-card-text class="my-3">
        <v-select
          v-model="form.variant"
          :items="variants"
          :disabled="form.$busy || loadingVariants"
          :loading="loadingVariants"
          :error-messages="form.$getError('variant_id')"
          label="Select Membership Variant"
          item-text="description"
          item-value="id"
          outlined
          flat
        />
      </v-card-text>

      <v-divider class="mb-3" />

      <v-card-actions class="px-5 pb-5">
        <v-spacer />

        <v-btn
          color="primary"
          :loading="form.$busy"
          @click="show = false"
          outlined
          rounded
        >
          Cancel
        </v-btn>

        <v-btn
          color="secondary"
          :loading="form.$busy"
          :disabled="!form.variant"
          @click="addNewMembership"
          rounded
        >
          Add New Membership
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Membership from '@/models/Membership'
import Form from '@/utils/form'

import { mdiTrashCanOutline } from '@mdi/js'
import { mapActions, mapMutations } from 'vuex'

export default {
  name: 'AssignNewMembership',

  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      variants: [],
      membership: null,
      loadingVariants: false,
      show: this.value,
      icons: {
        remove: mdiTrashCanOutline,
      },
      form: new Form({
        is_default: false,
        user_id: this.$route.params.id,
        variant: null,
      }),
    }
  },

  methods: {
    ...mapActions({
      assignNewUserMembership: 'users/assignNewUserMembership',
    }),

    ...mapMutations({
      attachNewMembership: 'userProfile/attachNewMembership',
    }),

    async fetchPlatinumMembership() {
      this.loadingVariants = true
      try {
        const { data } = await Membership.where('search', 'Platinum')
          .include('variants')
          .where('completed', true)
          .params({ limit: 1 })
          .get()

        if (data.length) {
          this.membership = data[0]
          this.variants = data[0].variants.filter(
            (variant) => variant.is_manual_assignable
          )
        }
      } finally {
        this.loadingVariants = false
      }
    },

    async addNewMembership() {
      this.form.$busy = true
      this.form.$clearErrors()

      await this.assignNewUserMembership({
        userId: this.$route.params.id,
        membershipId: this.membership.id,
        variantId: this.form.variant,
      })
        .then(({ data }) => {
          setTimeout(() => {
            this.form.$busy = false
            this.setData(data.data)
            this.show = false
            this.$emit('reloadMembershipHistory')
          }, 600)
        })
        .catch(({ response }) => {
          setTimeout(() => {
            this.form.$busy = false

            if (response && response.status === 403) {
              this.form.$setErrors({ membership: [response.data.message] })
            }

            if (response && response.status === 422) {
              this.form.$setErrors(response.data.errors)
            }
          }, 600)
        })
    },

    setData(data) {
      this.attachNewMembership(data)
    },
  },

  watch: {
    value(val) {
      this.show = val
    },

    show(val) {
      this.$emit('input', val)

      if (val) {
        this.fetchPlatinumMembership()
      } else {
        this.form.variant = null
        this.variants = []
        this.membership = null
      }
    },
  },
}
</script>
